export const FILE_SIZE = {
    FIVE_MB: {
        value: 5 * 1024 * 1024,
        label: "5 MB"
    },
    TEN_MB: {
        value: 10 * 1024 * 1024,
        label: "10 MB"
    },
    TWENTY_FIVE_MB: {
        value: 25 * 1024 * 1024,
        label: "25 MB"
    },
    FIFTY_MB: {
        value: 50 * 1024 * 1024,
        label: "50 MB"
    },
    FIVE_GB: {
        value: 5 * 1024 * 1024 * 1024,
        label: "5 GB"
    }
};
